import { Component, OnInit } from "@angular/core";
import { formatMessage } from "devextreme/localization";
import DevExpress from "devextreme";
import ToastType = DevExpress.ui.dxToast.ToastType;

@Component({
  selector: "app-printing-template",
  templateUrl: "./printing-template.component.html",
  styleUrls: ["./printing-template.component.scss"],
})
export class PrintingTemplateComponent implements OnInit {
  formatMessage = formatMessage;

  showToast = false;
  toastMessage = "For some reason we need an initial value here...";
  toastType = "default" as ToastType;

  constructor() {}

  ngOnInit(): void {}
}
